import React from "react";
import { Typography, Box, Button } from "@mui/material";
import SkillsView from "./SkillsView";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getRequestHeaders } from "../../utilities/auth/request";
const SkillMappings = () => {
  const [sortDirection, setSortDirection] = React.useState("asc");
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [sortedData, setSortedData] = useState(null);
  const handleSkillClick = (skill) => {
    setSelectedSkill(skill);
  };

  const { isPending, isError, data, error } = useQuery({
    queryKey: ["skills-view"],
    queryFn: async () => {
      const request = getRequestHeaders("get", "");
      const response = await fetch(`/ui/fetchSkillMappings`, request);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return await response.json();
    },
  });
  useEffect(() => {
    if (data && Object.entries(data).length > 0) {
      setSelectedSkill(Object.keys(data)[0]);
    }
  }, [data]);

  if (isPending) {
    return <span>Loading...</span>;
  }

  if (isError) {
    return <span>Error: {error.message}</span>;
  }

  const sortMethod = (direction) => {
    let sortedData = { ...data };
    const sortedArray = Object.entries(sortedData).sort(([keyA], [keyB]) => {
      if (direction === "asc") {
        return keyA.localeCompare(keyB);
      } else {
        return keyB.localeCompare(keyA, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      }
    });
    sortedData = Object.fromEntries(sortedArray);
    setSortedData(sortedData);
  };
  const handleSortClick = () => {
    const newSortDirection = sortDirection === "asc" ? "desc" : "asc";
    setSortDirection(newSortDirection);
    sortMethod(newSortDirection);
  };

  return (
    <>
      <Typography
        variant="h4"
        component={"div"}
        sx={{
          marginBottom: "1rem",
        }}
      >
        Skill Mappings
      </Typography>
      <Box
        sx={{ backgroundColor: "white" }}
        width={"100%"}
        height={"calc(100vh - 128px)"}
        overflow={"auto"}
      >
        <Box display={"flex"} width={"30%"} justifyContent={"space-between"}>
          <Typography
            variant="h6"
            component={"div"}
            sx={{
              p: "1rem",
              fontWeight: "400",
              fontSize: "24px",
            }}
          >
            View Skills
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="outlined"
              onClick={handleSortClick}
              startIcon={
                sortDirection === "asc" ? (
                  <ArrowUpwardIcon />
                ) : (
                  <ArrowDownwardIcon />
                )
              }
            >
              Sort
            </Button>
          </Box>
        </Box>
        <SkillsView
          data={sortedData || data}
          selectedSkill={selectedSkill}
          handleSkillClick={handleSkillClick}
        />
      </Box>
    </>
  );
};

export default SkillMappings;
